var Component = require("vue-loader/lib/component-normalizer")(
  /* name */
  "Icon",
  /* script */
  require("!!buble-loader!vue-loader/lib/selector?type=script&index=0!./../../../node_modules/eslint-loader/index.js!./Icon.vue"),
  /* template */
  require("!!vue-loader/lib/template-compiler?id=data-v-4f69ccb4!vue-loader/lib/template-loader?raw&engine=pug!vue-loader/lib/selector?type=template&index=0!./../../../node_modules/eslint-loader/index.js!./Icon.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/Icon.vue
// module id = 100
// module chunks = 0